<template>
  <div class="grid grid-cols-1 grid-rows-[auto_1fr] bg-neutral-50 px-8 py-4 text-xs shadow-xs">
    <div class="flex flex-row gap-2 overflow-x-auto">
      <font-awesome-icon
        :icon="['fal', 'arrow-left']"
        class="mr-2 h-4 w-4 cursor-pointer hover:text-primary-500"
        @click="router.back()"
      />
      <template v-for="parentRoute of routes" :key="parentRoute.name">
        <router-link :to="parentRoute.to" class="cursor-pointer hover:text-primary-500">
          {{ t(parentRoute.label) }}
        </router-link>
        <div>/</div>

        <div class="font-bold">
          {{ t(route.meta?.breadcrumb as string) }}
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useParentRoutes } from '@infuse/ui/services';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

interface Emits {
  (e: 'reload-model'): void;

  (e: 'submit'): void;
}

const emit = defineEmits<Emits>();

defineProps<{ model?: any }>();

const { t } = useI18n();

const router = useRouter();
const parentRoutes = useParentRoutes();
const route = useRoute();

// TODO: We also need to show the history of the route, so that the information in the breadcrumb is correct.
const routes = computed(() =>
  parentRoutes.value
    .filter((route) => !route.meta?.hidden && !!route.meta?.breadcrumb)
    .map((route) => ({
      name: route.name?.toString() ?? route.path,
      label: (route.meta?.breadcrumb as string) ?? '',
      to: route.name ? { name: route.name } : route.path
    }))
);
</script>
